<p-table #dt2 styleClass="tw-w-full p-datatable-striped" [value]="data" dataKey="id" [expandedRowKeys]="data" [paginator]="true" [totalRecords]="totalCount" [rows]="pageSize" [lazy]="true"
 (onLazyLoad)="load($event)" [responsive]="false" [resizableColumns]="true" [loading]="loading" [globalFilterFields]="['user', 'dateOnly', 'changeNamesString']">
  <ng-template pTemplate="header">
    <tr>
      <th>
        <p-multiSelect (onChange)="onFilterChange()" styleClass="tw-m-2 tw-w-full md:tw-w-auto md:tw-mr-2" [options]="users" placeholder="Select User" 
          [(ngModel)]="filter.users" [filter]="true" filterBy="label" appendTo="body" [selectedItemsLabel]="'{0} users selected'"/>
      </th>
      <th>
        <p-calendar (ngModelChange)="onDateChange($event)" styleClass="tw-m-2 tw-w-full md:tw-w-auto md:tw-mr-2" placeholder="Select Date"
        [(ngModel)]="dateRange" [maxDate]="maxDate" selectionMode="range"  dateFormat="MM dd, yy" showButtonBar="true" appendTo="body"/>
      </th>
      <th>
        <p-multiSelect (onChange)="onFilterChange()" styleClass="tw-m-2 tw-w-full md:tw-w-auto md:tw-mr-2" [options]="fields" placeholder="Select Field Type" 
        [(ngModel)]="filter.fields" [filter]="true" filterBy="label" appendTo="body" [selectedItemsLabel]="'{0} fields selected'" />
      </th>
      <th class="tw-align-middle">
        <button class="tw-m-2 md:tw-mr-2" type="button" pButton label="Clear" (click)="onClearFilters()"></button>
      </th>
    </tr>
    <tr>
        <th></th>
        <th pResizableColumn> Changed By </th>
        <th [colSpan]="2" pResizableColumn> Changed On </th>                
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-row let-expanded="expanded">
    <tr>
        <td>
          <p-button type="button" pRipple [pRowToggler]="row" [text]="true" [rounded]="true" [plain]="true" [icon]="expanded ? 'pi pi-chevron-up' : 'pi pi-chevron-down'" />
        </td>
        <td>{{row?.user}}</td>
        <td [colSpan]="2">{{row?.date | date:'MMMM dd, yyyy hh:mm a':'UTC'}}</td>
    </tr>
  </ng-template>
  <ng-template pTemplate="rowexpansion" let-row>
    <td colspan="4">
      <p-table styleClass="tw-w-full p-datatable-striped" [value]="row?.dataObject.Changes" [responsive]="false" [resizableColumns]="true">
        <ng-template pTemplate="header">
          <tr>
              <th></th>
              <th pResizableColumn> FIELDS </th>
              <th colspan="3" pResizableColumn> CHANGES </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-change>
          <tr>
              <td></td>
              <td><b>{{getFieldFriendlyName(change.Name)}}</b></td>
              <td colspan="3">
                <div *ngIf="change.OldValue || change.NewValue" class="value-container">
                  <p>
                    <b>Old Value:</b> {{change.OldValue}}
                  </p>
                  <p>
                    <b>New Value:</b> {{change.NewValue}}
                  </p>
                </div>
                <div *ngIf="change.Added"><b>Added Value:</b> 
                  <div *ngFor='let value of change.Added; let i = index;'>
                    {{value.Name}}
                    <div *ngIf="value.Changes">
                      <div *ngFor='let nested of value.Changes;' class="nested-change">
                        {{getFieldFriendlyName(nested.Name)}}: {{nested.OldValue}} -> {{nested.NewValue}}
                      </div>
                      <br *ngIf="i + 1 < change.Added.length"/>
                    </div>
                  </div>
                </div>
                <div *ngIf="change.Updated"><b>Updated Value:</b> 
                  <div *ngFor='let value of change.Updated; let i = index;'>
                    {{getFieldFriendlyName(value.Name)}}
                    <br/>
                    <div *ngFor='let nested of value.Changes;' class="nested-change">
                      {{getFieldFriendlyName(nested.Name)}}: {{nested.OldValue}} -> {{nested.NewValue}}
                    </div>
                    <br *ngIf="i + 1 < change.Updated.length"/>
                  </div>
                </div>
                <div *ngIf="change.Removed"><b>Removed Value:</b> 
                  <div *ngFor='let value of change.Removed; let i = index;'>
                    {{value.Name}}
                    <div *ngIf="value.Changes">
                      <div *ngFor='let nested of value.Changes;' class="nested-change">
                        {{getFieldFriendlyName(nested.Name)}}: {{nested.OldValue}} -> {{nested.NewValue}}
                      </div>
                      <br *ngIf="i + 1 < change.Removed.length"/>
                    </div>
                  </div>
                </div>
              </td>
          </tr>
        </ng-template>
      </p-table>
    </td>
  </ng-template>
  <ng-template pTemplate="summary">
    <div class="tw-text-left">
        {{totalCount}} history records found.
    </div>
  </ng-template>
</p-table>